import "@fortawesome/fontawesome-free/css/all.min.css";
import React, { useEffect } from 'react';
import Navbar from './Navbar';
import { useLocation } from 'react-router-dom';
import { useSearchContext } from './SearchContext';

const Header = () => {
    const location = useLocation();
    const { isPrintView, buildLink } = useSearchContext();
    const pathname = location.pathname;

    const isViewDocumentPage = pathname.startsWith('/view-document');

    const excludedPaths = [
        '/search',
        '/advanced-search',
        '/freeform-search',
        '/browse',
        '/searchresults'
    ];

    const isExcludedPath = excludedPaths.includes(pathname) || isViewDocumentPage;

    useEffect(() => {
        const scriptId = 'ucf-university-header-script';
        const headerId = 'ucfhb';

        const removeUniversityHeader = () => {
            const existingScript = document.getElementById(scriptId);
            const existingHeader = document.getElementById(headerId);

            if (existingScript) {
                existingScript.remove();
            }
            if (existingHeader) {
                existingHeader.remove();
            }
        };

        const addUniversityHeader = () => {
            const existingScript = document.getElementById(scriptId);
            const existingHeader = document.getElementById(headerId);

            if (!existingScript && !existingHeader) {
                const script = document.createElement('script');
                script.src = 'https://universityheader.ucf.edu/bar/js/university-header.js';
                script.id = scriptId;
                script.type = 'text/javascript';
                script.async = true;
                document.head.appendChild(script);
            }
        };

        if (isExcludedPath) {
            removeUniversityHeader();
        } else {
            addUniversityHeader();
        }
    }, [pathname, isExcludedPath]);

    return (
        <>
            <div className="col-lg-12" id="navgap"></div>

            {/* Full header for non-search pages */}
            {!isExcludedPath && (
                <header className="app-header">
                    <div className="col-lg-6 col-sm-5">
                        <p className="topbar-logo d-none d-lg-flex">
                            <a href="/">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/header/logo.png`}
                                    alt="The Charles Brockden Brown Electronic and Scholarly Edition"
                                    className="screenlogo"
                                />
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/header/logo-print.png`}
                                    alt="The Charles Brockden Brown Electronic and Scholarly Edition"
                                    className="printlogo"
                                />
                            </a>
                        </p>

                        <p className="d-block d-lg-none text-center" style={{ padding: '2em 0 1em 0' }}>
                            <img
                                src={`${process.env.PUBLIC_URL}/images/header/logo-sm.png`}
                                alt="The Charles Brockden Brown Electronic and Scholarly Edition"
                                className="bannerlogo"
                            />
                        </p>
                    </div>

                    <div className="col-lg-6 col-sm-7">
                        <p className="index_search">
                            <span className="fas fa-search" style={{ color: '#ffffff' }} aria-hidden="true"></span>{' '}
                            <a
                                href={buildLink('/archive?section=access&anchor=accessheading')}
                                style={{ color: '#ffffff', fontSize: '175%' }}
                            >
                                Search the Archive
                            </a>
                        </p>
                    </div>
                </header>
            )}

            {/* Image header for search pages (except while in view-document's print view) */}
            {isExcludedPath && !(isViewDocumentPage && isPrintView) && (
                <div className="header-image">
                    <a href="/">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/header/logo_brockden.jpg`}
                            alt="Charles Brockden Brown Archive Header"
                        />
                    </a>
                </div>
            )}

            <Navbar />
        </>
    );
};

export default Header;
